import { render, staticRenderFns } from "./ReserveSource.vue?vue&type=template&id=0fcb52fb&scoped=true"
import script from "./ReserveSource.vue?vue&type=script&lang=js"
export * from "./ReserveSource.vue?vue&type=script&lang=js"
import style0 from "./ReserveSource.vue?vue&type=style&index=0&id=0fcb52fb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fcb52fb",
  null
  
)

export default component.exports